import React, { useState } from 'react';
import app from 'new-ui/app';

import PropTypes from 'prop-types';
import Biomarkers from 'new-ui/Components/Biomarkers';
import { PopupButton, PopupContent, PopupTitle } from 'new-ui/Components/Popup';

const BiomarkersPopup = (props) => {
  const {
    onSelect,
    biomarkers = [],
  } = props;
  const [_biomarkers, setBiomarkers] = useState(biomarkers);
  return (
    <div className="biomarkers-popup">
      <PopupTitle title="Biomarkers" />
      <PopupContent>
        <Biomarkers
          biomarkers={_biomarkers}
          onChange={(nextBiomarkers) => {
            setBiomarkers(nextBiomarkers);
          }}
        />
      </PopupContent>
      <PopupButton
        title="Save"
        action={() => {
          onSelect(_biomarkers);
          app.closeActivePopup();
        }}
      />
    </div>
  );
};

BiomarkersPopup.propTypes = {
  onSelect: PropTypes.func.isRequired,
  biomarkers: PropTypes.array,
};

export default BiomarkersPopup;
